export default __webpack_public_path__ + "static/media/trash-icon.a619ed93.svg";